import { render, staticRenderFns } from "./TenantSettings.vue?vue&type=template&id=14ccff5b&"
import script from "./TenantSettings.vue?vue&type=script&lang=ts&"
export * from "./TenantSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TenantSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports